import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";


export interface ISettingsState {
}

export const slice = createSlice({
    name: "settings",
    initialState: {

    } as ISettingsState,
    reducers: {

    },
});

export const { reducer } = slice;

export const actionCreators = {

};

export const { } = slice.actions;
